import {useRef, useState} from "react";
import styles from './useSliderHook.scss';
import {useHammerTimeHook} from "./useHammerTimeHook";

export function useSliderHook(itemsContainer, itemsContainerOuter, mobileBreakPoint, autoplay, infinite, hideMarginLeft) {

	const sliderRef = useRef(null);
	const [sliderInitialized, setSliderInitialized] = useState(false);
	const [animationComplete, setAnimationComplete] = useState(false);


	useHammerTimeHook(itemsContainer, itemsContainerOuter, mobileBreakPoint, hideMarginLeft);

	const settings = {
		slidesToShow: 1,
		slidesToScroll: 1,
		mobileFirst: true,
		dots: false,
		arrows: false,
		autoplay: autoplay,
		className: styles.slickSlider,
		infinite: infinite,
		variableWidth: false,
		onInit: () => {
			setSliderInitialized(true);
		}
	};

	return {
		settings,
		sliderRef,
		sliderInitialized,
		animationComplete,
		setAnimationComplete
	}
}
